import * as React from "react";

const ThumbtackIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
    >
        <g clipPath="url(#clip0_81_88)">
            <path fill="#009FD9" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0"></path>
            <path
                fill="#fff"
                d="M8.973 10.385a3.7 3.7 0 0 1-.564 1.957L8 13l-.409-.658a3.7 3.7 0 0 1-.564-1.957v-3.14C7.51 6.62 8.231 6.4 8.973 6.4zM4 5.69V4h8v1.69z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_81_88">
                <path fill="#fff" d="M0 0h16v16H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

export default ThumbtackIcon;
